import * as actionTypes from './actionTypes';
import { LoadableData } from './state';
import { Offer } from '../services/pricing';
import { ProductSpecs } from '../services/specs';
import { ProductShape } from '../services/products';
import { Project } from '../services/project';

export function createSetMPIdAction(mpId: string) {
  return {
    type: actionTypes.SET_MP_ID,
    mpId,
  };
}

export function createSetProjectIdAction(projectId: string) {
  return {
    type: actionTypes.SET_PROJECT_ID,
    projectId,
  };
}

export function createSetLoadableProjectAction(loadableProject: LoadableData<Project>) {
  return {
    type: actionTypes.SET_LOADABLE_PROJECT,
    loadableProject,
  };
}

export function createSetLoadableProductShapesAction(
  loadableProductShapes: LoadableData<ProductShape[]>,
) {
  return {
    type: actionTypes.SET_LOADABLE_PRODUCT_SHAPES,
    loadableProductShapes,
  };
}

export function createSetBaseOfferAction(loadableBaseOffer: LoadableData<Offer>) {
  return {
    type: actionTypes.SET_LOADABLE_BASE_OFFER,
    loadableBaseOffer,
  };
}

export function createSetPricingContextAction(loadablePricingContext: LoadableData<string>) {
  return {
    type: actionTypes.SET_LOADABLE_PRICING_CONTEXT,
    loadablePricingContext,
  };
}

export function createSetLoadableUpsellPricesBySKUAction(
  loadableUpsellPriceBySKU: LoadableData<{ [sku: string]: string }>,
) {
  return {
    type: actionTypes.SET_LOADABLE_UPSELL_PRICE_BY_SKU,
    loadableUpsellPriceBySKU,
  };
}

export function createSetLoadableProductSpecsBySKUAction(
  loadableProductSpecsBySKU: LoadableData<{ [sku: string]: ProductSpecs }>,
) {
  return {
    type: actionTypes.SET_LOADABLE_PRODUCT_SPECS_BY_SKU,
    loadableProductSpecsBySKU,
  };
}
